import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DirectivesModule } from '@directives/directives.module';
import { MatTooltipModule } from '@directives/ui-tooltip';
import { UiClickOutsideModule } from '@uipath/angular/directives/ui-click-outside';

import { UiActionExpanderComponent } from './ui-action-expander.component';

const EXPORTS = [
    UiActionExpanderComponent,
];

@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
        MatIconModule,
        MatButtonModule,
        DirectivesModule,
        UiClickOutsideModule,
    ],
    declarations: [
        ...EXPORTS,
    ],
    exports: [
        ...EXPORTS,
    ],
})
export class UiActionExpanderModule { }
